import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
const store = createPinia()
store.use(piniaPluginPersistedstate)
export default store
